import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { AuthService } from './auth.service';
import {
    ICreateUdEntitlementLineRequest,
    ICreateUdRegisterRequest,
    ICreateUdUtilizationRequest,
    IPage,
    IUdEntitlementLine,
    IUdRegister,
    IUdUtilization,
    IUpdateUdEntitlementLineRequest,
    IUpdateUdRegisterRequest,
    UdStatus,
} from '../interfaces/commercial.interface';

const headers = () => AuthService.getAuthHeader();

export const UdRegisterService = {
    list: async (institutionId: string, page = 0, size = 20, status?: UdStatus | ''): Promise<IPage<IUdRegister>> => {
        const params: Record<string, string | number> = { page, size };
        if (status) params.status = status;
        const res = await axios.get(ENDPOINTS.UD_REGISTER.LIST(institutionId), { headers: headers(), params });
        return res.data;
    },

    get: async (institutionId: string, udId: string): Promise<IUdRegister> =>
        (await axios.get(ENDPOINTS.UD_REGISTER.GET(institutionId, udId), { headers: headers() })).data,

    create: async (institutionId: string, request: ICreateUdRegisterRequest): Promise<IUdRegister> =>
        (await axios.post(ENDPOINTS.UD_REGISTER.CREATE(institutionId), request, { headers: headers() })).data,

    update: async (institutionId: string, udId: string, request: IUpdateUdRegisterRequest): Promise<IUdRegister> =>
        (await axios.put(ENDPOINTS.UD_REGISTER.UPDATE(institutionId, udId), request, { headers: headers() })).data,

    remove: async (institutionId: string, udId: string): Promise<void> => {
        await axios.delete(ENDPOINTS.UD_REGISTER.DELETE(institutionId, udId), { headers: headers() });
    },

    listLines: async (institutionId: string, udId: string, page = 0, size = 100): Promise<IPage<IUdEntitlementLine>> => {
        const res = await axios.get(ENDPOINTS.UD_REGISTER.LINES(institutionId, udId), { headers: headers(), params: { page, size } });
        return res.data;
    },

    createLine: async (institutionId: string, udId: string, request: ICreateUdEntitlementLineRequest): Promise<IUdEntitlementLine> =>
        (await axios.post(ENDPOINTS.UD_REGISTER.LINES(institutionId, udId), request, { headers: headers() })).data,

    updateLine: async (institutionId: string, udId: string, lineId: string, request: IUpdateUdEntitlementLineRequest): Promise<IUdEntitlementLine> =>
        (await axios.put(ENDPOINTS.UD_REGISTER.LINE(institutionId, udId, lineId), request, { headers: headers() })).data,

    deleteLine: async (institutionId: string, udId: string, lineId: string): Promise<void> => {
        await axios.delete(ENDPOINTS.UD_REGISTER.LINE(institutionId, udId, lineId), { headers: headers() });
    },

    listUtilizations: async (institutionId: string, udId: string, lineId: string, page = 0, size = 100): Promise<IPage<IUdUtilization>> => {
        const res = await axios.get(ENDPOINTS.UD_REGISTER.UTILIZATIONS(institutionId, udId, lineId), { headers: headers(), params: { page, size } });
        return res.data;
    },

    createUtilization: async (institutionId: string, udId: string, lineId: string, request: ICreateUdUtilizationRequest): Promise<IUdUtilization> =>
        (await axios.post(ENDPOINTS.UD_REGISTER.UTILIZATIONS(institutionId, udId, lineId), request, { headers: headers() })).data,

    deleteUtilization: async (institutionId: string, udId: string, lineId: string, utilId: string): Promise<void> => {
        await axios.delete(ENDPOINTS.UD_REGISTER.UTILIZATION(institutionId, udId, lineId, utilId), { headers: headers() });
    },
};
